import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

/**
 * Per-period earnings + time + counts. `hours*` values are SUM of `duration`
 * in MINUTES (divide by 60 for hours). `blocked` is the count of personal-time
 * slots.
 */
/** One day in the week-at-a-glance breakdown (present on the `week` block). */
export interface WeekDay {
    date: string; // "YYYY-MM-DD" (location-local)
    count: number; // non-cancelled bookings (done + waiting)
    isWorkingDay: boolean;
}

export interface EarningsRange {
    received: number;
    expected: number;
    hoursReceived: number;
    hoursExpected: number;
    hoursBlocked: number;
    done: number;
    waiting: number;
    canceled: number;
    blocked: number;
    /** Per-day Mon-start breakdown — only populated on the `week` block. */
    days?: WeekDay[];
}

export interface Overview {
    today: EarningsRange;
    week: EarningsRange;
    month: EarningsRange;
    /** Master's monthly revenue target, or null when unset. */
    monthlyRevenueGoal: number | null;
    /** Master's desired monthly working hours, or null when unset. */
    monthlyHoursGoal: number | null;
    /** Lifetime non-cancelled (Done+Wait) bookings — drives the home XOR gate. */
    lifetimeActiveBookings: number;
}

export default class EarningsOverview {
    /**
     * The home screen's single data source. "Now" (today/week/month) is derived
     * server-side in the location's timezone, so no date is passed.
     */
    public static readonly info = async (
        uuid: string,
        brand: string,
        location: string
    ) =>
        (await axios
            .get(
                `${environment.api_url}/${brand}/location/${location}/analytics/earnings-overview`,
                { headers: { "User-Token": uuid } }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as Overview | undefined;
}
